import React, { useState, useEffect, useRef } from "react";
import { Table, Input, Tabs, Form, Checkbox, InputNumber, Dropdown, Menu, Button, message, Spin,Popover,List } from "antd";
import moment from "moment";
import { Link } from "react-router-dom";
import { useGlobalData } from "./../../context/GlobalDataContext";
import SelectCorporate from "./components/ui/SelectCorporate";
import { CheckCircle, DollarSign, Mail, AlertCircle } from "react-feather";
import Select from "react-select";
import axios from "axios";
import Swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import generateInvoice from "./invoices/frontOffice";
import exportService from '../../pages/hms/utils/exportService';
import InvoicePreview from "./components/popups/InvoicePreview";
import UserService from "./utils/userService";
import { renderDate } from "./utils/dateFormatter";
import PrintReportPreview from "./reports/PrintReportPreview";
import DatePicker from "react-bootstrap-daterangepicker";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import { DownOutlined } from "@ant-design/icons";
import CryptoJS from "crypto-js";

const InvoiceList = () => {
  const businessDate = localStorage.getItem("business_date"); // e.g., "2025-02-23"
  const timestamp = new Date().toISOString().replace(/[:.-]/g, ""); // For uniqueness
  const suffix = `_business_date_${businessDate}_${timestamp}`;
  const [pdfVisible, setPdfVisible] = useState(false);
  const [pdfData, setPdfData] = useState(null);
  const maximizeBtnRef = useRef(null);
  const [isFullScreen, setFullScreen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(moment(businessDate || new Date()));
  const [searchText, setSearchText] = useState("");
  const [invoices, setInvoices] = useState([]);
  const [applicableTaxes, setApplicableTaxes] = useState([]); // New state for applicable taxes
  const [listLoading, setListLoading] = useState(false);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [error, setError] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [form] = Form.useForm();
  const submitButtonRef = useRef(null);
  const currencyCode = localStorage.getItem("currencycode") || "$";
  const [invoiceModalVisible, setInvoiceModalVisible] = useState(false);
  const [invoiceHtml, setInvoiceHtml] = useState(null);
  const [invoiceUrl, setInvoiceUrl] = useState(null);
  const [currentInvoiceId, setCurrentInvoiceId] = useState(null);
  const [isRefund, setIsRefund] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const { Search } = Input;
  const { TabPane } = Tabs;
    const secretKey = "abde100199199111";

  const apiURL = process.env.REACT_APP_API_URL || "https://api.example.com";
  const cdnUrl = process.env.REACT_APP_CDN_URL || "";
  const [dateRange, setDateRange] = useState({
    startDate: moment(businessDate).startOf("day"),
    endDate: moment(businessDate).startOf("day"),
  });
  const [outputType, setOutputType] = useState("pdf");

  useEffect(() => {
    const handleClick = () => {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen().catch((err) => {
          console.error("Failed to enter fullscreen:", err);
        });
        setFullScreen(true);
      } else {
        document.exitFullscreen().catch((err) => {
          console.error("Failed to exit fullscreen:", err);
        });
        setFullScreen(false);
      }
    };

    const handleFullscreenChange = () => {
      setFullScreen(!!document.fullscreenElement);
    };

    const maximizeBtn = maximizeBtnRef.current;
    if (maximizeBtn) {
      maximizeBtn.addEventListener("click", handleClick);
    }

    document.addEventListener("fullscreenchange", handleFullscreenChange);

    return () => {
      if (maximizeBtn) {
        maximizeBtn.removeEventListener("click", handleClick);
      }
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      if (document.fullscreenElement) {
        document.exitFullscreen().catch((err) => {
          console.error("Failed to exit fullscreen during cleanup:", err);
        });
      }
    };
  }, []);

  useEffect(() => {
    fetchInvoices(dateRange.startDate, dateRange.endDate);
  }, []);

  const fetchInvoices = async (startDate, endDate) => {
    if (!startDate || !endDate || !moment(startDate).isValid() || !moment(endDate).isValid()) {
      setListLoading(false);
      setError("Invalid date range provided.");
      setInvoices([]);
      setApplicableTaxes([]);
      return;
    }

    setListLoading(true);
    setError(null);
    const token = localStorage.getItem("token");

    if (!token) {
      setListLoading(false);
      setError("Authentication token missing. Please log in again.");
      setInvoices([]);
      setApplicableTaxes([]);
      window.location.href = "/login";
      return;
    }

    try {
      const response = await axios.get(`${apiURL}/transactions/list-invoices`, {
        params: {
          startDate: startDate.format("YYYY-MM-DD"),
          endDate: endDate.format("YYYY-MM-DD"),
        },
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!response.data || !Array.isArray(response.data.invoices)) {
        throw new Error("Invalid response format: invoices must be an array.");
      }

      const parsedInvoices = response.data.invoices.map(invoice => {
        const amountPaid = typeof invoice.amount_paid === "string" && !isNaN(invoice.amount_paid)
          ? Number(invoice.amount_paid)
          : 0;

        return {
          ...invoice,
          total_amount: Number(invoice.total_amount) || 0,
          tax: Number(invoice.tax) || 0,
          amount_paid: amountPaid,
          grand_total: Number(invoice.grand_total) || 0,
          balance_due: Number(invoice.balance_due) || 0,
        };
      });

      setInvoices(parsedInvoices);
      setApplicableTaxes(response.data.applicableTaxes || []); // Store applicable taxes
      return { data: { invoices: parsedInvoices, applicableTaxes: response.data.applicableTaxes || [] } };
    } catch (err) {
      console.error("Fetch invoices error details:", {
        message: err.message,
        response: err.response ? {
          status: err.response.status,
          data: err.response.data,
        } : "No response",
        request: err.request ? err.request : "No request",
      });
      if (err.response && err.response.status === 401) {
        setError("Session expired. Please log in again.");
        localStorage.removeItem("token");
        window.location.href = "/login";
      } else {
        let errorMessage = "Failed to load invoices for the selected date range.";
        if (err.response && err.response.data && err.response.data.message) {
          errorMessage = err.response.data.message;
        } else if (err.message) {
          errorMessage = err.message;
        }
        setError(errorMessage);
        toast.error(errorMessage, { autoClose: 3000 });
      }
      setInvoices([]);
      setApplicableTaxes([]);
    } finally {
      setListLoading(false);
    }
  };

  const handleSwitchView = async (newOutputType) => {
    try {
      setPreviewLoading(true);
      const result = await generateInvoice(currentInvoiceId, "invoice", "preview", newOutputType);
      
      if (newOutputType === "html") {
        setInvoiceHtml(result);
        if (invoiceUrl) {
          URL.revokeObjectURL(invoiceUrl);
        }
        setInvoiceUrl(null);
      } else {
        if (!(result instanceof Blob)) {
          throw new Error("Generated invoice is not a valid Blob.");
        }
        const url = URL.createObjectURL(result);
        setInvoiceUrl(url);
        setInvoiceHtml(null);
      }

      setOutputType(newOutputType);
    } catch (error) {
      console.error("Error switching invoice view:", error);
      toast.error("Failed to switch view.", { autoClose: 3000 });
    } finally {
      setPreviewLoading(false);
    }
  };

  const handleDateChange = async (param) => {
    setDateRange((prevRange) => {
      let newRange;
      if (typeof param === "string") {
        if (param === "prev") {
          newRange = {
            startDate: prevRange.startDate.clone().subtract(1, "day").startOf("day"),
            endDate: prevRange.endDate.clone().subtract(1, "day").startOf("day"),
          };
        } else if (param === "next") {
          newRange = {
            startDate: prevRange.startDate.clone().add(1, "day").startOf("day"),
            endDate: prevRange.endDate.clone().add(1, "day").startOf("day"),
          };
        } else {
          return prevRange;
        }
      } else {
        const { start, end } = param;
        newRange = {
          startDate: moment(start).startOf("day"),
          endDate: moment(end).startOf("day"),
        };
      }

      if (!newRange.startDate.isValid() || !newRange.endDate.isValid()) {
        setError("Invalid date selected.");
        setInvoices([]);
        setApplicableTaxes([]);
        return prevRange;
      }

      if (newRange.startDate.isAfter(newRange.endDate)) {
        setError("Start date cannot be after end date.");
        setInvoices([]);
        setApplicableTaxes([]);
        return prevRange;
      }

      fetchInvoices(newRange.startDate, newRange.endDate)
        .then((response) => {
          setInvoices(response.data.invoices);
          setApplicableTaxes(response.data.applicableTaxes || []);
        })
        .catch((error) => {
          console.error("Error fetching invoices:", error);
          let errorMessage = "Failed to load invoices for the selected date range.";
          if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message;
          } else if (error.message) {
            errorMessage = error.message;
          }
          setError(errorMessage);
          setInvoices([]);
          setApplicableTaxes([]);
          toast.error(errorMessage, { autoClose: 3000 });
        });

      return newRange;
    });
  };

  const settledInvoices = invoices.filter((inv) => inv.balance_due === 0);
  const unsettledInvoices = invoices.filter((inv) => inv.balance_due !== 0);

  const filteredSettledInvoices = settledInvoices.filter((invoice) =>
    invoice.invoice_number.toLowerCase().includes(searchText.toLowerCase())
  );
  const filteredUnsettledInvoices = unsettledInvoices.filter((invoice) =>
    invoice.invoice_number.toLowerCase().includes(searchText.toLowerCase())
  );

  // Generate dynamic tax columns
  const taxColumns = applicableTaxes.map((taxName) => ({
    title: `${taxName} ${currencyCode}`,
    dataIndex: taxName,
    render: (amount) => `${(amount || 0).toFixed(2)}`,
    sorter: (a, b) => (a[taxName] || 0) - (b[taxName] || 0),
  }));

  // Define base columns
  const baseColumns = [
{
  title: "Invoice Number",
  dataIndex: "invoice_number",
  sorter: (a, b) => a.invoice_number.localeCompare(b.invoice_number),
  render: (text, record) => {
    const balance_due = record.balance_due;
    const statusLabel =
      balance_due === 0 ? "Settled" : balance_due < 0 ? "Refund Due" : "Unsettled";
    const statusClass =
      balance_due === 0 ? "bg-success" : balance_due < 0 ? "bg-info" : "bg-warning";

    return (
      <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
        {/* Invoice number + email icon */}
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              handleGenerateInvoice(record.id, "html");
            }}
            style={{
              color: "#1890ff",
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            {text}
          </a>
          <Mail
            size={16}
            color="#1890ff"
            style={{ cursor: "pointer" }}
            onClick={() => sendEmail(record)}
            title="Send Invoice Email"
          />
        </div>



        {/* Settle button (only if balance_due !== 0) */}
        {balance_due !== 0 && (
          <button
            className="btn btn-primary btn-sm mt-1"
            style={{ padding: "2px 6px", fontSize: "0.75rem", alignSelf: "flex-start" }}
            onClick={() => handleSettleInvoice(record)}
          >
            Settle Invoice
          </button>
        )}
      </div>
    );
  },
}

,
    {
      title: "Guest Name",
      render: (record) => `${record.guest_name}`,
      sorter: (a, b) => a.guest_name.localeCompare(b.guest_name),
    },

{
  title: "Reservation ID",
  render: (record) => {
    try {
      const encryptedId = CryptoJS.AES.encrypt(
        record.reservation_id.toString(),
        secretKey
      ).toString();
      return (
        <Link
          to={`/hospitality/reservation-details/${encodeURIComponent(encryptedId)}`}
          className="colored-box reservation-no-box"
        >
          {record.booking_number}
        </Link>
      );
    } catch (error) {
      console.error("Encryption Error:", error);
      return <span className="colored-box reservation-no-box">Error</span>;
    }
  },
  sorter: (a, b) => a.reservation_id.toString().localeCompare(b.reservation_id.toString()),
},
    {
      title: "Room No",
      render: (record) => `${record.room_number}`,
      sorter: (a, b) => a.room_number.localeCompare(b.room_number),
    },
    {
      title: "Invoice Date",
      dataIndex: "invoice_date",
      render: (date) => (
        <span className="date-box check-in-box">{renderDate(date)}</span>
      ),
      sorter: (a, b) => moment(a.invoice_date).unix() - moment(b.invoice_date).unix(),
    },
    {
      title: `Total Amount ${currencyCode}`,
      dataIndex: "total_amount",
      sorter: (a, b) => a.total_amount - b.total_amount,
      render: (amount) => `${(amount || 0).toFixed(2)}`,
    },
    // Tax breakdown columns will be inserted here
    {
      title: `Tax ${currencyCode}`,
      dataIndex: "tax",
      render: (amount) => `${(amount || 0).toFixed(2)}`,
    },
    {
      title: `Grand Total ${currencyCode}`,
      dataIndex: "grand_total",
      sorter: (a, b) => a.grand_total - b.grand_total,
      render: (amount) => `${(amount || 0).toFixed(2)}`,
    },
    {
      title: `Aamount Paid ${currencyCode}`,
      dataIndex: "amount_paid",
      sorter: (a, b) => a.amount_paid - b.amount_paid,
      render: (amount) => `${(amount || 0).toFixed(2)}`,
    },
    {
      title: `Balance Due ${currencyCode}`,
      dataIndex: "balance_due",
      sorter: (a, b) => a.balance_due - b.balance_due,
      render: (amount) => (
        <span
          className={amount > 0 ? "text-danger" : amount < 0 ? "text-success" : "text-success"}
          style={{ fontSize: "1.0em" }}
        >
          {(amount || 0).toFixed(2)}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "balance_due",
      render: (balance_due) => (
        <span
          className={`badge px-3 py-2 ${balance_due === 0 ? "bg-success" : balance_due < 0 ? "bg-info" : "bg-warning"}`}
          style={{ fontSize: "0.9rem", width: "100px", color: "#ffffff", fontWeight: "normal", display: "inline-block", textAlign: "center" }}
        >
          {balance_due === 0 ? "Settled" : balance_due < 0 ? "Refund Due" : "Unsettled"}
        </span>
      ),
    },
    {
      title: "Billed To",
      dataIndex: "billed_to",
    },
    {
      title: "Company Name",
      dataIndex: "company_name",
      render: (name) => name || "-",
    },
    {
      title: "Payment Method",
      dataIndex: "payment_method",
      key: 'payment_method',
    render: (paymentMethods) => (
      <Popover
        content={
          <List
            dataSource={paymentMethods}
            renderItem={(item) => (
              <List.Item>
                <div>
                  <strong>Date:</strong> {item.chargeDate} <br />
                  <strong>Mode:</strong> {item.paymentMode} <br />
                  <strong>Amount:</strong> ₹{item.totalAmount}
                </div>
              </List.Item>
            )}
          />
        }
        title="Payment Methods"
        trigger="click"
      >
        <Button type="link">View Payments ({paymentMethods.length})</Button>
      </Popover>
    ),
  },
    {
      title: "Action",
      key: "action",
      render: (_, record) =>
        record.balance_due !== 0 ? (
          <button className="btn btn-primary btn-sm" onClick={() => handleSettleInvoice(record)}>
            Settle Invoice
          </button>
        ) : null,
    },
  ];

  // Insert tax columns before the "Tax" column
  const taxColumnIndex = baseColumns.findIndex((col) => col.dataIndex === "tax");
  const columns = [
    ...baseColumns.slice(0, taxColumnIndex),
    ...taxColumns,
    ...baseColumns.slice(taxColumnIndex),
  ];

  // Update export headers to include tax breakdown columns
  const exportHeaders = [
    { key: "invoice_number", title: "Invoice Number" },
    { key: "guest_name", title: "Guest Name / Reservation ID" },
    { key: "room_number", title: "Room No" },
    { key: "invoice_date", title: "Invoice Date" },
    { key: "total_amount", title: `Total Amount ${currencyCode}` },
    ...applicableTaxes.map((taxName) => ({
      key: taxName,
      title: `${taxName} ${currencyCode}`,
    })),
    { key: "tax", title: `Tax ${currencyCode}` },
    { key: "grand_total", title: `Grand Total ${currencyCode}` },
    { key: "amount_paid", title: `Advance ${currencyCode}` },
    { key: "balance_due", title: `Balance Due ${currencyCode}` },
    { key: "status", title: "Status" },
    { key: "billed_to", title: "Billed To" },
    { key: "company_name", title: "Company Name" },
    { key: "payment_method", title: "Payment Method" },
  ];

  const exportData = (data) =>
    data.map((invoice) => ({
      invoice_number: invoice.invoice_number,
      guest_name: invoice.guest_name,
      room_number: invoice.room_number,
      invoice_date: renderDate(invoice.invoice_date),
      total_amount: (invoice.total_amount || 0).toFixed(2),
      ...applicableTaxes.reduce((acc, taxName) => ({
        ...acc,
        [taxName]: (invoice[taxName] || 0).toFixed(2),
      }), {}),
      tax: (invoice.tax || 0).toFixed(2),
      grand_total: (invoice.grand_total || 0).toFixed(2),
      amount_paid: (invoice.amount_paid || 0).toFixed(2),
      balance_due: (invoice.balance_due || 0).toFixed(2),
      status: invoice.balance_due === 0 ? "Settled" : invoice.balance_due < 0 ? "Refund Due" : "Unsettled",
      billed_to: invoice.billed_to || "",
      company_name: invoice.company_name || "-",
      payment_method: invoice.payment_method || "",
    }));

  const getTotals = (data) => {
    const totalInvoices = data.length;
    const totalGrandTotal = data.reduce((sum, inv) => sum + (inv.grand_total || 0), 0).toFixed(2);
    const totalBalanceDue = data.reduce((sum, inv) => sum + (inv.balance_due || 0), 0).toFixed(2);
    const taxTotals = applicableTaxes.reduce((acc, taxName) => ({
      ...acc,
      [taxName]: data.reduce((sum, inv) => sum + (inv[taxName] || 0), 0).toFixed(2),
    }), {});
    return [
      { key: "Total Invoices", value: totalInvoices },
      { key: "Total Grand Total", value: `${currencyCode}${totalGrandTotal}` },
      { key: "Total Balance Due", value: `${currencyCode}${totalBalanceDue}` },
      ...applicableTaxes.map((taxName) => ({
        key: `${taxName} Total`,
        value: `${currencyCode}${taxTotals[taxName]}`,
      })),
    ];
  };

  const handleExportXLS = () => {
    const tabData = activeTab === "1" ? filteredSettledInvoices : filteredUnsettledInvoices;
    const totals = getTotals(tabData);
    exportService.exportToXLS(
      exportData(tabData),
      exportHeaders,
      `invoice_list${suffix}.xlsx`,
      "Invoice List",
      totals
    );
  };

  const handleExportCSV = () => {
    const tabData = activeTab === "1" ? filteredSettledInvoices : filteredUnsettledInvoices;
    const totals = getTotals(tabData);
    exportService.exportToCSV(
      exportData(tabData),
      exportHeaders,
      `invoice_list${suffix}.csv`,
      totals
    );
  };

  const handleExportPDF = async () => {
    const tabData = activeTab === "1" ? filteredSettledInvoices : filteredUnsettledInvoices;
    const totals = getTotals(tabData);
    exportService.exportToPDF(
      exportData(tabData),
      exportHeaders,
      "Invoice List",
      `invoice_list${suffix}.pdf`,
      false,
      true,
      totals,
      totals
    );
  };

  const handlePrint = async () => {
    try {
      setPreviewLoading(true);
      const tabData = activeTab === "1" ? filteredSettledInvoices : filteredUnsettledInvoices;
      const totals = getTotals(tabData);
      const pdfBlob = await exportService.exportToPDF(
        exportData(tabData),
        exportHeaders,
        "Invoice List",
        null,
        true,
        true,
        totals,
        totals
      );
      const pdfUrl = URL.createObjectURL(pdfBlob);
      setPdfData(pdfUrl);
      setPdfVisible(true);
    } catch (error) {
      console.error("Error generating PDF for preview:", error);
      message.error("Failed to load PDF preview.");
    } finally {
      setPreviewLoading(false);
    }
  };

  const downloadMenu = (
    <Menu>
      <Menu.Item key="xls" onClick={handleExportXLS}>Download XLS</Menu.Item>
      <Menu.Item key="csv" onClick={handleExportCSV}>Download CSV</Menu.Item>
      <Menu.Item key="print" onClick={handlePrint}>Print Preview</Menu.Item>
    </Menu>
  );

  const paymentMethods = [
    { value: "CASH", label: "Cash" },
    { value: "BANK_TRANSFER", label: "Bank Transfer" },
    { value: "UPI", label: "UPI" },
    { value: "CARD", label: "Credit Card" },
    { value: "CHEQUE", label: "Cheque" },
  ];

  const handleSettleInvoice = (invoice) => {
    setSelectedInvoice(invoice);
    setModalVisible(true);
    setIsRefund(invoice.balance_due < 0);
    form.setFieldsValue({
      billToCompany: false,
      company: null,
      payments: [{ method: "", amount: "", reference: "" }],
      dueAmount: invoice.balance_due,
      bookingId: invoice.booking_id,
    });
  };

  const handleGenerateInvoice = async (invoiceId, outputType = "html") => {
    try {
      setPreviewLoading(true);
      setInvoiceModalVisible(true);

      const result = await generateInvoice(invoiceId, "invoice", "preview", outputType);
      
      if (outputType === "html") {
        setInvoiceHtml(result);
        if (invoiceUrl) {
          URL.revokeObjectURL(invoiceUrl);
        }
        setInvoiceUrl(null);
      } else {
        if (!(result instanceof Blob)) {
          throw new Error("Generated invoice is not a valid Blob.");
        }
        const url = URL.createObjectURL(result);
        setInvoiceUrl(url);
        setInvoiceHtml(null);
      }

      setCurrentInvoiceId(invoiceId);
      setOutputType(outputType);
    } catch (error) {
      console.error("Error generating invoice:", error);
      toast.error("Failed to generate invoice.", { autoClose: 3000 });
    } finally {
      setPreviewLoading(false);
    }
  };

  const handleCloseInvoiceModal = () => {
    setInvoiceModalVisible(false);
    if (invoiceUrl) {
      URL.revokeObjectURL(invoiceUrl);
      setInvoiceUrl(null);
    }
    setInvoiceHtml(null);
    setCurrentInvoiceId(null);
  };

  const handleModalOk = async () => {
    try {
      const values = await form.validateFields();
      const totalPaid = values.payments ? values.payments.reduce((sum, p) => sum + (p.amount || 0), 0) : 0;
      const isRefund = selectedInvoice.balance_due < 0;
      const balanceDueAbs = Math.abs(selectedInvoice.balance_due);

      if (!isRefund) {
        if (!values.billToCompany && (!values.payments || values.payments.length === 0)) {
          toast.error("Please add at least one payment method or select Bill to Company.", { autoClose: 3000 });
          return;
        }
        if (totalPaid > selectedInvoice.balance_due) {
          toast.error("Total payment exceeds balance due!", { autoClose: 3000 });
          return;
        }
        if (!values.billToCompany && totalPaid < selectedInvoice.balance_due) {
          toast.error("Total payment must match the balance due unless billed to company.", { autoClose: 3000 });
          return;
        }
      } else {
        if (!values.payments || values.payments.length === 0) {
          toast.error("Please add at least one payment method for the refund.", { autoClose: 3000 });
          return;
        }
        if (totalPaid !== balanceDueAbs) {
          toast.error("Total refund amount must match the balance due.", { autoClose: 3000 });
          return;
        }
      }

      const confirmation = await Swal.fire({
        title: isRefund ? "Confirm Refund" : "Confirm Payment",
        text: isRefund
          ? `Are you sure you want to refund ${currencyCode}${totalPaid.toFixed(2)} for invoice #${selectedInvoice.invoice_number}?`
          : `Are you sure you want to settle invoice #${selectedInvoice.invoice_number} for ${currencyCode}${totalPaid.toFixed(2)}?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: isRefund ? "Yes, Refund" : "Yes, Settle",
        cancelButtonText: "No",
        confirmButtonColor: "#007bff",
        cancelButtonColor: "#dc3545",
      });

      if (!confirmation.isConfirmed) {
        return;
      }

      const paymentPayload = isRefund
        ? values.payments.map((payment) => ({
            amount_paid: payment.amount,
            payment_mode: payment.method,
            payment_reference: payment.reference || null,
            payment_date: moment().format("YYYY-MM-DD"),
            invoice_id: selectedInvoice.id,
            bookingId: selectedInvoice.reservation_id,
            refund: true,
            refund_amount: payment.amount,
          }))
        : values.billToCompany
        ? [{
            amount_paid: selectedInvoice.balance_due,
            payment_mode: "COMPANY",
            payment_reference: values.company?.value || null,
            payment_date: moment().format("YYYY-MM-DD"),
            invoice_id: selectedInvoice.id,
            bookingId: selectedInvoice.reservation_id,
          }]
        : values.payments.map((payment) => ({
            amount_paid: payment.amount,
            payment_mode: payment.method,
            payment_reference: payment.reference || null,
            payment_date: moment().format("YYYY-MM-DD"),
            invoice_id: selectedInvoice.id,
            bookingId: selectedInvoice.reservation_id,
          }));

      setListLoading(true);
      const token = localStorage.getItem("token");

      const response = await axios.post(`${apiURL}/transactions/add-invoice-payment`, paymentPayload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 200 && (response.data.success === undefined || response.data.success)) {
        setInvoices((prev) =>
          prev.map((inv) =>
            inv.id === selectedInvoice.id
              ? {
                  ...inv,
                  balance_due: isRefund ? 0 : values.billToCompany ? 0 : inv.balance_due - totalPaid,
                  payment_method: values.billToCompany
                    ? "Billed to Company"
                    : values.payments.map((p) => `${p.method} (${currencyCode}${p.amount})`).join(", "),
                  billed_to: values.billToCompany ? "Company" : isRefund ? "Refund" : "Self",
                  company_name: values.billToCompany ? values.company?.label : "",
                }
              : inv
          )
        );
        setModalVisible(false);
        toast.success(isRefund ? "Refund processed successfully!" : "Invoice settled successfully!", { autoClose: 2000 });
      } else {
        toast.error(`Failed to ${isRefund ? "process refund" : "settle invoice"}: ${response.data.message || "Unknown error"}`, { autoClose: 3000 });
      }
    } catch (err) {
      if (err.errorFields) {
        toast.error("Please fill all required fields.", { autoClose: 3000 });
      } else if (err.response) {
        toast.error(`Error ${isRefund ? "processing refund" : "settling invoice"}: ${err.response.data.message || err.message || "Unknown error"}`, { autoClose: 3000 });
      } else {
        toast.error(`Error ${isRefund ? "processing refund" : "settling invoice"}: ${err.message || "Unknown error"}`, { autoClose: 3000 });
      }
    } finally {
      setListLoading(false);
    }
  };

  const sendEmail = async (record) => {
    const guestEmail = record.guest_email?.trim();
    const guestName = record.guest_name || "Guest";

    if (!guestEmail) {
      await Swal.fire({
        title: "Email Missing",
        text: `${guestName} doesn't have an email associated. You can update the email from the Guest Reservation Details page to send the invoice.`,
        icon: "warning",
        confirmButtonText: "OK",
        confirmButtonColor: "#d33",
      });
      return;
    }

    const confirmation = await Swal.fire({
      title: "Send Invoice Email",
      text: `Are you sure you want to send the invoice email to ${guestEmail}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Send",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
    });

    if (confirmation.isConfirmed) {
      try {
        const response = await generateInvoice(record.id, "invoice", "email");
        await Swal.fire({
          title: "Email Sent",
          text: response?.message || `Invoice email sent successfully to ${guestEmail}!`,
          icon: "success",
          confirmButtonText: "OK",
          confirmButtonColor: "#3085d6",
        });
      } catch (error) {
        await Swal.fire({
          title: "Error",
          text: error.message || `Failed to send invoice email to ${guestEmail}. Please try again.`,
          icon: "error",
          confirmButtonText: "OK",
          confirmButtonColor: "#d33",
        });
      }
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <div className="page-header page-top-icons">
          <div className="d-flex align-items-center justify-content-between mb-4" style={{ position: "relative" }}>
            <div className="d-flex align-items-center gap-3">
              <h2 className="mb-0">Invoices</h2>
              <DatePicker
                initialSettings={{
                  singleDatePicker: false,
                  showDropdowns: true,
                  startDate: dateRange.startDate.toDate(),
                  endDate: dateRange.endDate.toDate(),
                  ranges: {
                    "Today": [dateRange.startDate.toDate(), dateRange.startDate.toDate()],
                    "This Week": [
                      moment(dateRange.startDate).startOf("week").toDate(),
                      moment(dateRange.startDate).endOf("week").toDate(),
                    ],
                    "This Month": [
                      moment(dateRange.startDate).startOf("month").toDate(),
                      moment(dateRange.startDate).endOf("month").toDate(),
                    ],
                    "Next Month": [
                      moment(dateRange.startDate).add(1, "month").startOf("month").toDate(),
                      moment(dateRange.startDate).add(1, "month").endOf("month").toDate(),
                    ],
                  },
                  locale: {
                    format: "DD MMM YYYY",
                    applyLabel: "Select",
                    cancelLabel: "Cancel",
                  },
                }}
                onCallback={(start, end) => handleDateChange({ start, end })}
              >
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    value={`${dateRange.startDate.format("DD MMM YYYY")} - ${dateRange.endDate.format("DD MMM YYYY")}`}
                    style={{
                      width: "220px",
                      height: "38px",
                      fontSize: "16px",
                      fontWeight: "bold",
                      textAlign: "center",
                      borderRight: "none",
                      backgroundColor: "#ffffff",
                    }}
                    readOnly
                  />
                  <div className="input-group-append">
                    <span
                      className="input-group-text"
                      style={{
                        height: "38px",
                        backgroundColor: "#fff",
                        borderLeft: "none",
                        borderRadius: "0 4px 4px 0",
                        cursor: "pointer",
                      }}
                    >
                      <i className="fa fa-chevron-down" style={{ color: "#495057" }} />
                    </span>
                  </div>
                </div>
              </DatePicker>
            </div>
            <div className="position-absolute" style={{ left: "50%", transform: "translateX(-50%)" }}>
              <Search
                placeholder="Search by Invoice Number"
                allowClear
                enterButton="Search"
                size="large"
                onChange={(e) => setSearchText(e.target.value)}
                style={{ width: 300 }}
              />
            </div>
            <div className="d-flex align-items-center gap-2">
              <Link to="#" className="btn btn-link" id="collapse-header" ref={maximizeBtnRef}>
                <i className="las la-expand-arrows-alt" />
              </Link>
              <Dropdown overlay={downloadMenu} trigger={["click"]} placement="bottomRight">
                <Button className="custom-btn-drop d-inline-flex align-items-center" type="text">
                  <i className="la la-download custom-icon me-2" /> Download <DownOutlined className="ms-2" />
                </Button>
              </Dropdown>
            </div>
          </div>
        </div>

        <PrintReportPreview
          visible={pdfVisible}
          onClose={() => {
            setPdfVisible(false);
            setPdfData(null);
            if (pdfData) URL.revokeObjectURL(pdfData);
          }}
          reportTitle="Invoice List"
          propertyName="Your Property Name"
          data={exportData(activeTab === "1" ? filteredSettledInvoices : filteredUnsettledInvoices)}
          headers={exportHeaders}
          footerData={getTotals(activeTab === "1" ? filteredSettledInvoices : filteredUnsettledInvoices)}
          totalColumns={["total_amount", ...applicableTaxes, "tax", "grand_total", "balance_due"]}
          onDownloadPDF={handleExportPDF}
          apiEndpoint="transactions/generate-pdf"
          apiUrl={apiURL}
        />

        {listLoading ? (
          <div id="loader-wrapper-">
            <div className="loader">
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
            </div>
          </div>
        ) : (
          <div className="table-responsive">
            {error ? (
              <p className="text-danger text-center">{error}</p>
            ) : (
              <>
                <Tabs activeKey={activeTab} onChange={(key) => setActiveTab(key)}>
                  <TabPane
                    tab={
                      <span className="fw-bold d-flex align-items-center" style={{ fontSize: "1.05rem" }}>
                        <CheckCircle size={20} className="me-2 text-success" />
                        Paid Invoices ({settledInvoices.length})
                      </span>
                    }
                    key="1"
                  >
                    {filteredSettledInvoices.length === 0 ? (
                      <div className="no-data-container text-center mt-4">
                        <img
                          src="https://ui-cdn.digitalocean.com/apps/ui-spaces/static/media/spaces-empty.5e1d7947c43b7e336b14e421d4a86639.svg"
                          alt="No data available"
                          style={{ width: "150px", marginBottom: "20px" }}
                        />
                        <h3>No Paid Invoices</h3>
                        <p>There are no paid invoices in the selected date range.</p>
                      </div>
                    ) : (
                      <Table
                        columns={columns.filter((col) => col.key !== "action")}
                        dataSource={filteredSettledInvoices}
                        pagination={{ pageSize: 30 }}
                        className="table-striped"
                        rowKey={(record) => record.id}
                      />
                    )}
                  </TabPane>
                  <TabPane
                    tab={
                      <div className="d-flex align-items-center text-danger fw-bold" style={{ fontSize: "1.1rem", color: "#dc3545" }}>
                        <AlertCircle size={20} className="me-2" />
                        Outstanding Invoices ({unsettledInvoices.length})
                      </div>
                    }
                    key="2"
                  >
                    {filteredUnsettledInvoices.length === 0 ? (
                      <div className="no-data-container text-center mt-4">
                        <img
                          src="https://ui-cdn.digitalocean.com/apps/ui-spaces/static/media/spaces-empty.5e1d7947c43b7e336b14e421d4a86639.svg"
                          alt="No data available"
                          style={{ width: "150px", marginBottom: "20px" }}
                        />
                        <h3>No Outstanding Invoices</h3>
                        <p>There are no outstanding invoices in the selected date range.</p>
                      </div>
                    ) : (
                      <Table
                        columns={columns}
                        dataSource={filteredUnsettledInvoices}
                        pagination={{ pageSize: 20 }}
                        className="table-striped"
                        rowKey={(record) => record.id}
                      />
                    )}
                  </TabPane>
                </Tabs>
              </>
            )}
          </div>
        )}

        {modalVisible && selectedInvoice && (
          <div id="settle_invoice" className="modal custom-modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}>
            <div
              className="modal-dialog modal-lg shadow-lg"
              style={{
                margin: 0,
                position: "fixed",
                right: 0,
                height: "100vh",
                width: "40%",
                borderRadius: "10px 0 0 10px",
                overflow: "hidden",
                background: "linear-gradient(135deg, #ffffff, #f8f9fa)",
              }}
              role="document"
            >
              <Form form={form} style={{ height: "100%", display: "flex", flexDirection: "column" }}>
                <div className="modal-content h-100 border-0">
                  <div
                    className="modal-header bg-primary text-white d-flex justify-content-between align-items-center"
                    style={{ borderBottom: "2px solid #e9ecef", padding: "1rem 1.5rem" }}
                  >
                    <h5 className="modal-title fw-bold m-0" style={{ fontSize: "1.3rem" }}>
                      {selectedInvoice.balance_due < 0 ? (
                        <span style={{ color: "#dc3545" }}>
                          {currencyCode}{Math.abs(selectedInvoice.balance_due).toFixed(2)} Refund
                        </span>
                      ) : (
                        `Settle Invoice #${selectedInvoice.invoice_number}`
                      )}
                    </h5>
                    <button
                      type="button"
                      className="btn-close btn-close-white"
                      aria-label="Close"
                      onClick={() => setModalVisible(false)}
                      style={{ filter: "brightness(100%)" }}
                    />
                  </div>

                  <div className="modal-body p-4" style={{ maxHeight: "calc(100vh - 180px)", overflowY: "auto", background: "#fff" }}>
                    <div className="mb-4 p-3 bg-light rounded shadow-sm">
                      <p className="mb-2"><strong className="text-muted">Guest Name:</strong> <span className="fw-bold">{selectedInvoice.guest_name}</span></p>
                      <p className="mb-2"><strong className="text-muted">Room No:</strong> <span className="fw-bold">{selectedInvoice.room_number || "N/A"}</span></p>
                      <p className="mb-0">
                        <strong className="text-muted">{selectedInvoice.balance_due < 0 ? "Refund Amount" : "Balance Due"}:</strong>
                        <span className={`fw-bold ${selectedInvoice.balance_due < 0 ? "text-success" : "text-danger"}`}>
                          {currencyCode}{(Math.abs(selectedInvoice.balance_due) || 0).toFixed(2)}
                        </span>
                      </p>
                    </div>

                    {selectedInvoice.balance_due >= 0 && (
                      <Form.Item name="billToCompany" valuePropName="checked">
                        <Checkbox className="fw-bold">Bill to Company</Checkbox>
                      </Form.Item>
                    )}

                    <Form.Item
                      noStyle
                      shouldUpdate={(prev, curr) => prev.billToCompany !== curr.billToCompany}
                    >
                      {({ getFieldValue, setFieldsValue }) =>
                        selectedInvoice.balance_due >= 0 && getFieldValue("billToCompany") ? (
                          <Form.Item
                            name="company"
                            label="Select Company"
                            rules={[{ required: true, message: "Please select a company" }]}
                          >
                            <SelectCorporate
                              onSelectCompany={(selected) => {
                                setFieldsValue({ company: selected });
                                console.log("Selected Company:", selected);
                              }}
                              selectedValue={getFieldValue("company")?.value || null}
                            />
                          </Form.Item>
                        ) : null
                      }
                    </Form.Item>

                    <Form.Item
                      noStyle
                      shouldUpdate={(prev, curr) => prev.billToCompany !== curr.billToCompany}
                    >
                      {({ getFieldValue }) =>
                        selectedInvoice.balance_due < 0 || !getFieldValue("billToCompany") ? (
                          <Form.List name="payments">
                            {(fields, { add, remove }) => (
                              <>
                                {fields.map((field, index) => (
                                  <div key={field.key} className="d-flex align-items-center mb-3 p-2 bg-light rounded shadow-sm">
                                    <Form.Item
                                      {...field}
                                      name={[field.name, "method"]}
                                      fieldKey={[field.fieldKey, "method"]}
                                      rules={[{ required: true, message: "Payment method is required" }]}
                                      style={{ width: "35%", marginRight: "10px" }}
                                    >
                                      <Select
                                        options={paymentMethods}
                                        placeholder="Payment Method"
                                        styles={{
                                          control: (base) => ({ ...base, borderRadius: "8px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }),
                                          option: (base) => ({ ...base, fontWeight: "500" }),
                                        }}
                                      />
                                    </Form.Item>
                                    <Form.Item
                                      {...field}
                                      name={[field.name, "amount"]}
                                      fieldKey={[field.fieldKey, "amount"]}
                                      rules={[{ required: true, message: "Amount is required" }]}
                                      style={{ width: "25%", marginRight: "10px" }}
                                    >
                                      <InputNumber
                                        min={0}
                                        max={Math.abs(selectedInvoice.balance_due)}
                                        placeholder="Amount"
                                        style={{ width: "100%", borderRadius: "8px" }}
                                        addonBefore={currencyCode}
                                      />
                                    </Form.Item>
                                    <Form.Item
                                      {...field}
                                      name={[field.name, "reference"]}
                                      fieldKey={[field.fieldKey, "reference"]}
                                      rules={[{ required: true, message: "Reference is required" }]}
                                      style={{ width: "30%", marginRight: "10px" }}
                                    >
                                      <Input
                                        placeholder="Reference"
                                        style={{ borderRadius: "8px" }}
                                      />
                                    </Form.Item>
                                    {fields.length > 1 && (
                                      <button className="btn btn-link text-danger" onClick={() => remove(field.name)}>
                                        <i className="fas fa-trash" />
                                      </button>
                                    )}
                                  </div>
                                ))}
                                <button
                                  className="btn btn-outline-secondary btn-block"
                                  onClick={() => add()}
                                  disabled={fields.length >= paymentMethods.length}
                                  style={{ borderRadius: "8px", marginBottom: "20px" }}
                                >
                                  <i className="fas fa-plus me-2" /> Add Payment Method
                                </button>
                              </>
                            )}
                          </Form.List>
                        ) : null
                      }
                    </Form.Item>
                  </div>

                  <div className="modal-footer p-3 bg-light border-top" style={{ boxShadow: "0 -2px 10px rgba(0,0,0,0.05)" }}>
                    <button
                      className="btn btn-secondary me-2"
                      onClick={() => setModalVisible(false)}
                      style={{ borderRadius: "8px", padding: "8px 20px" }}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary"
                      disabled={listLoading}
                      onClick={handleModalOk}
                      style={{ borderRadius: "8px", padding: "8px 20px" }}
                    >
                      {listLoading ? (selectedInvoice.balance_due < 0 ? "Refunding..." : "Settling...") : (selectedInvoice.balance_due < 0 ? "Process Refund" : "Settle Invoice")}
                    </button>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        )}

        <InvoicePreview
          showModal={invoiceModalVisible}
          onClose={handleCloseInvoiceModal}
          pdfUrl={invoiceUrl}
          htmlContent={invoiceHtml}
          guestDetails={{}}
          type="invoice"
          outputType={outputType}
          handleSwitchView={handleSwitchView}
          loading={previewLoading}
        />
      </div>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} closeOnClick pauseOnHover draggable />
    </div>
  );
};

export default InvoiceList;